import React from 'react';

import IconType from '../../../types/Icon';

const PlusSmall: React.FC<IconType> = ({ color = 'currentColor', size = 16 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path d="M7 2V7H2V9H7V14H9V9H14V7H9V2H7Z" fill={color} />
		</svg>
	);
};

export default PlusSmall;
